import React from "react";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

function Services() {
  useDocumentTitle("Services");
  return (
    <div className="container py-4">
      <h1>Services</h1>
      <p>Service information is coming soon.</p>
    </div>
  );
}

export default Services;
